import Client from '../HttpClient';

const baseUrl = '/admin/api/menu-group-times';

const list = () => {
	return Client.get(baseUrl);
};

const find = (id) => {
	return Client.get(`${baseUrl}/${id}`);
};

const create = (payload) => {
	return Client.post(`${baseUrl}`, payload);
};

const update = (id, payload) => {
	return Client.put(`${baseUrl}/${id}`, payload);
};

const remove = (id) => {
	return Client.del(`${baseUrl}/${id}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
